import { defaultKlaytnProviderConfiguration } from 'src/features/on-chain/calculation-manager/providers/dexes/klaytn/default-constants';

export const CLAIM_SWAP_CONTRACT_ADDRESS = '0xEf71750C100f7918d6Ded239Ff1CF09E81dEA92D';

export const CLAIM_SWAP_PROVIDER_CONFIGURATION = defaultKlaytnProviderConfiguration;
